import React, { createContext, useContext, useReducer, useState } from "react";
import { searchReducer } from "../reducer/searchReducer";


const initialState = {
    productsList: [],
    searchTearm: "",
    addItem:()=>{},
    removeItem:()=>{},
    search:() =>{},
    clearCart:()=>{},
    userCart:()=>{},
    productQuantity: ()=>{},
    newCart: ()=>{},
}
// we decler the values in the context
export const SearchContext = createContext(initialState);

export const SearchContextProvider = ({ children }) => {
  const [productsList, setProductsList] = useState([]);

  const updateProductQuantity = (productId, newQuantity) => {
      setProductsList(prevList => 
          prevList.map(product => 
              product.p_id === productId 
                  ? { ...product, quantity: newQuantity }
                  : product
          )
      );
      console.log("productsList from the search context", productsList);
  };
    const [state , dispatch] = useReducer(searchReducer, initialState)

    const addItemToCart = async (product) => {
      console.log("product from the search context 00001", product);
      console.log("product from the search context 00002", product.p_id);
        const existingProductIndex = state.productsList.findIndex(item => item.p_id === product.p_id);
      console.log("product from the search context 00003", existingProductIndex);

        if (existingProductIndex !== -1) {
            const updatedCart = state.productsList.map((item, index) => 
                index === existingProductIndex ? { ...item, quantity: item.quantity + 1 } : item
            );
            dispatch({
                type: "UPDATE_CART",
                payload: { products: updatedCart }
            });
        } else {
            const updatedCart = [...state.productsList, { ...product, quantity: 1 }];
            dispatch({
                type: "ADD_TO",
                payload: { products: updatedCart }
            });
        }
    }
    
    const removeItemFromCart = (product) => {
        const existingProductIndex = state.productsList.findIndex(item => item.p_id === product.p_id);
        console.log("removeItemFromCart from search context 00004", existingProductIndex);

        if (existingProductIndex !== -1) {
          const updatedCart = state.productsList.map((item, index) => 
            index === existingProductIndex ? { ...item, quantity: item.quantity - 1 } : item
          )
          // .filter(item => item.quantity > 0);
          dispatch({
            type: "UPDATE_CART",
            payload: { products: updatedCart }
          });
        }
      };

      const clearAllItemsFromCart = () => {
        dispatch({
          type: "CLEAR_CART",
          payload: { products: [] }
        });
      };


      const initialUserCart = async (cartItems) => {
        console.log("cartItems from the search context", cartItems);
  
        const userSavedCart = cartItems
        dispatch({
          type: "INITIAL_USER_CART",
          payload: { products: userSavedCart }
        });
      }

    const searchForItem = (searchValue) =>{
      console.log("searchValue from the search context", searchValue);
        dispatch({
            type: "SEARCH_VALUE",
            payload:{
                searchTearm:searchValue
            }
        })
    }

    const setTheCartItems = (new_cart)=>{
        dispatch({
          type: "CLEAR_CART",
          payload: { products: [] }
        })

        dispatch({
          type: "UPDATE_CART",
          payload: { products: new_cart }
        });
    }


  const ctxValue = {
    productsList: state.productsList,
    searchTearm: state.searchTearm,
    addItem:addItemToCart,
    removeItem:removeItemFromCart,
    search: searchForItem,
    clearCart:clearAllItemsFromCart,
    userCart:initialUserCart,
    productQuantity :updateProductQuantity,
    newCart : setTheCartItems
  };
  //we providing it to all other files
  return (
    <SearchContext.Provider value={ctxValue}>
        {children}
    </SearchContext.Provider>
  );
}

export const useSearch = ()=>{
    const context = useContext(SearchContext)
    return context
}
